{
  "accountLandingLinkTo": "Cuenta",
  "accountLandingTitle": "Configuraciones de la cuenta",
  "accountSettingsTitle": "Configuraciones de la cuenta",
  "activeFarmTitle": "Granja activa",
  "adminModeToggle": "Modo de administrador",
  "adminUser": "Usuario administrador",
  "adminUserIndicatorWithEmail": "{{email}} (usuario administrador)",
  "appInfoClearCache": "Borrar caché",
  "appInfoExpireFarmCache": "Actualizar caché de datos de la granja",
  "appInfoExpireFarmCacheSuccess": "Caché de datos de la granja actualizada",
  "appInfoIsDemoModeActive": "Modo de demostración habilitado",
  "appInfoLinkTo": "Información de la aplicación",
  "appInfoTitle": "Información de la aplicación",
  "appInfoUpdateId": "Actualizar ID",
  "appInfoVersion": "Versión",
  "appNotificationsLinkTo": "Anuncios",
  "appNotificationsListEmpty": "No hay anuncios en este momento. Vuelva a consultar más tarde.",
  "appNotificationsTitle": "Anuncios",
  "appPreferences": "Preferencias de la aplicación",
  "changeFarmsListActiveDevicesWithItemCount": "{{itemCount}} dispositivos activos",
  "changeFarmsListListEmpty": "Su cuenta no está vinculada a ninguna granja activa.",
  "changeFarmsListSubheaderwithFarmName": "Granja activa: {{farmName}}",
  "changeFarmsListTitle": "Sus cuentas agrícolas",
  "checkForUpdatesButtonText": "Buscar actualizaciones",
  "checkForUpdatesError": "Error al obtener la última actualización de la aplicación",
  "yourAppIsUpToDate": "Tu aplicación está actualizada",
  "checkForUpdatesYourAppIsUpToDate": "Tu aplicación está actualizada",
  "companySectionTitle": "Sobre nosotros",
  "contactUsLink": "Contáctenos",
  "crashButton": "Chocar",
  "darkModeToggle": "Modo oscuro",
  "farmJoinCodeTitle": "Código de ingreso a la granja",
  "farmUsersListLink": "Usuarios de la granja",
  "internalOnlySectionTitle": "Solo para uso interno",
  "linkTo": "Cuenta",
  "measurementPreferenceLabel": "Medidas",
  "measurementPreferenceValues": {
    "metric": "Métrico",
    "us": "EE.UU."
  },
  "nameFirstInputLabel": "Nombre de pila",
  "nameFirstInputPlaceholder": "(Introduzca su nombre)",
  "nameLastInputLabel": "Apellido",
  "nameLastInputPlaceholder": "(Introduzca su apellido)",
  "newFarmAccount": "Nueva cuenta de granja",
  "phoneNumbersListLink": "Números de teléfono",
  "shareFeedbackLink": "Compartir comentarios",
  "supportedLanguages": {
    "en": "🇺🇸 Inglés (Estados Unidos)",
    "es": "🇲🇽 Español (MX)",
    "fr": "🇫🇷 Francés",
    "it": "🇮🇹 Italian"
  },
  "supportedLanguagesTitle": "Idioma preferido",
  "userAccountTitle": "Mi cuenta",
  "userFarmsListLinkTo": "Sus cuentas agrícolas",
  "userFarmsListListEmpty": "Su cuenta no está vinculada a ninguna granja activa.",
  "userFarmsListNoOtherFarms": "Su cuenta no está vinculada a ninguna otra granja",
  "userFarmsListSubheaderWithActiveFarmName": "Granja activa: {{activeFarmName}}",
  "userFarmsListTitle": "Sus cuentas agrícolas",
  "userNameFormCollectionDisclaimer": "Recopilamos esta información para realizar un seguimiento de quiénes son nuestros clientes y brindar la mejor experiencia de servicio al cliente posible. No compartimos esta información con terceros.",
  "userNameFormCollectionTitle": "Recopilación de datos: Nombre de usuario",
  "userNameFormInstructions": "Para poder brindar la mejor experiencia posible de servicio al cliente, necesitamos cierta información suya:",
  "userNameFormTitle": "Nombre de usuario",
  "userNameWithNameGivenAndNameFamily": "{{nameGiven}} {{nameFamily}}",
  "viewDebugInfoButton": "Ver información de depuración",
  "viewFarmUserPermissionsLinkTo": "Ver sus permisos",
  "viewFarmUserPermissionsTitle": "Sus permisos",
  "viewPrivacyPolicyLinkTo": "Ver política de privacidad",
  "viewPrivacyPolicyTitle": "política de privacidad",
  "deleteAccountLinkTo": "Eliminar cuenta",
  "deleteAccountTitle": "Eliminar cuenta",
  "deleteAccountWarning": "Esta acción es permanente y no se puede deshacer. Su cuenta será desactivada, su información personal será eliminada y se cerrará su sesión.",
  "deleteAccountConfirmationLabel": "Escriba DELETE para confirmar",
  "deleteAccountConfirmationPlaceholder": "DELETE",
  "deleteAccountConfirmButton": "Eliminar mi cuenta",
  "deleteAccountOwnedFarmsWarning": "Debe transferir la propiedad o desactivar las siguientes granjas antes de eliminar su cuenta:",
  "transferOwnershipLinkTo": "Transferir propiedad",
  "transferOwnershipTitle": "Transferir propiedad de la granja",
  "transferOwnershipDescription": "Seleccione un miembro de la granja para que sea el nuevo propietario.",
  "transferOwnershipSuccess": "Propiedad transferida exitosamente.",
  "deactivateFarmLinkTo": "Desactivar granja",
  "deactivateFarmTitle": "Desactivar granja",
  "deactivateFarmWarning": "Esto desactivará la granja, eliminará el acceso de todos los miembros y liberará todos los dispositivos.",
  "deactivateFarmConfirmButton": "Desactivar granja",
  "leaveFarmLinkTo": "Salir de la granja",
  "leaveFarmConfirmMessage": "¿Está seguro de que desea salir de esta granja?",
  "leaveFarmConfirmButton": "Salir de la granja"
}
